import { JSEncrypt } from 'jsencrypt'
import { getAttrList } from '@frame/api/common/index'
import { hex_md5 } from '@frame/utils/encry'
/**
 * 数据非对称加密
 * @param {String} data      明文
 * @param {String} publicKey 公钥
 * @returns {String}         密文
 */
export const encrypt = (data, publicKey) => {
  if (!data || !publicKey) {
    console && console.warn('Encrypt data or publicKey is undefined.')
    return ''
  }
  let encryptor = new JSEncrypt()// 新建JSEncrypt对象
  encryptor.setPublicKey(publicKey)// 设置公钥
  // 对数据进行加密
  return encryptor.encrypt(data)// 返回加密后的数据
}
/**
 * 计算表格高度
 */
export function calculateHeight () {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let mainEl = getEl('page-main')[0]
      let searchEl = getEl('search-box')
      let toobarEl = getEl('datagrid-toolbar')
      let pageEl = getEl('page-box-r')
      let obj = {
        search: typeof searchEl[0] === 'undefined' ? 'undefined' : searchEl[0],
        toobar: typeof toobarEl[0] === 'undefined' ? 'undefined' : toobarEl[0],
        paging: typeof pageEl[0] === 'undefined' ? 'undefined' : pageEl[0]
      }
      let height = 25
      Object.keys(obj).forEach((key, index) => {
        if (obj[key] != 'undefined') {
          height += obj[key].clientHeight
        }
      })
      resolve(mainEl.clientHeight - height)
    }, 110)
  })
}

/**
 * 兼容非谷歌和火狐浏览器
 * @date 2020-5-22
 * @param {*} arr
 */
function getEncDecode (arr) {
  if (navigator.userAgent.indexOf('Firefox') > -1 || navigator.userAgent.indexOf('Chrome') > -1) {
    console.log('谷歌火狐')
    return new TextDecoder('utf-8').decode(Uint8Array.from(arr))
  } else {
    console.log('非谷歌火狐')
    return decodeURIComponent(escape(arr))
  }
}

/**
 * 文件预览
 * @param {*} url
 * @param {*} option
 */
export function fileView (url, option) {
  return imageHandle(url, option, '预览文件失败')
}
/**
 * 生成图片验证码
 * @param {*} url
 * @param {*} option
 */
export function createVerifyCode (url, option) {
  return imageHandle(url, option, '生成图片验证码失败')
}
/**
 * 文件下载
 * @param {*} url
 * @param {*} option
 */
export function fileDownload (url, option) {
  return new Promise((resolve, reject) => {
    window.fetch.post(url, option, {
      responseType: 'arraybuffer'
    }).then(r => {
      if (r && r.request.response) {
        let resp = r.request.response
        let uarray = new Uint8Array(resp)
        let text = getEncDecode(uarray)
        let result = isJSONObject(text)
        if (result === false) {
          let dis = r.headers['content-disposition']
          let name = window.decodeURI(dis.split('=')[1])
          downloadFileHandle(resp, name)
          return resolve({ success: true, errorInfo: '下载文件成功' })
        }
        return resolve(result)
      }
      return reject(new Error({ errorNo: -1, errorInfo: '下载文件失败', success: false }))
    }).catch(e => {
      if (e.response && e.response.data) {
        return reject(getEncDecode(new Uint8Array(e.response.data)))
      }
      return reject(new Error({ errorNo: -1, errorInfo: '下载文件失败', success: false }))
    })
  })
}

/**
 * 图片处理函数
 * @param {*} url
 * @param {*} option
 * @param {*} errorInfo
 */
function imageHandle (url, option, errorInfo) {
  return new Promise((resolve, reject) => {
    window.fetch.post(url, option).then(r => {
      if (r) {
        let resp = r.data
        let text = resp.image
        let token = resp.token
        return resolve({ success: true, data: 'data:image/png;base64,' + text, token: token })
      }
      return reject(new Error({ errorNo: -1, errorInfo: errorInfo, success: false }))
    }).catch(e => {
      if (e.response && e.response.data) {
        return reject(getEncDecode(new Uint8Array(e.response.data)))
      }
      return reject(new Error({ errorNo: -1, errorInfo: errorInfo, success: false }))
    })
  })
}

function isJSONObject (str) {
  try {
    return JSON.parse(str)
  } catch (e) {
    return false
  }
}
function byte2String (byte) {
  return String.fromCharCode(byte)
}
/**
 * 下载文件
 * @param {*} data
 * @param {*} fileName
 */
function downloadFileHandle (data, fileName) {
  let ourl = window.URL
  let url = ourl.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  ourl.revokeObjectURL(url) // 释放掉blob对象
  link.remove()// 删除超链接标签
}
function getEl (cls) {
  return document.getElementsByClassName(cls)
}
export function fTime (time) {
  if (typeof (time) === 'undefined' || time === 'undefined') {
    return ''
  }
  time = '' + time
  return time.substring(0, 4) + '/' + time.substring(4, 6) + '/' + time.substring(6, 8) + ' ' + time.substring(8, 10) + ':' + time.substring(10, 12) + ':' + time.substring(12, 14)
}

// 密码校验
export function pwdPassVlitor (rule, value, callback) {
  const field = rule.field
  let attrKeys = 'password'
  if (field === 'newPayPassword' || field === 'newPayPasswordCheck') {
    attrKeys = 'payPass'
  }

  getAttrList({ 'attrKeys': attrKeys }).then(r => {
    if (r.data.success) {
      let item = r.data.items[0]
      let reg = evil('/' + item.checkRule + '/')
      if (!reg.test(value)) {
        return callback(new Error(item.checkRuleTips))
      } else {
        return callback()
      }
    }
    return callback(new Error(r.data.errorInfo))
  }).catch(e => {
    console.error(e)
    return callback(new Error('校验失败'))
  })
}

function evil (fn) {
  var Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
  return new Fn('return ' + fn)()
}

// 密码校验
export function encode (str) {
  return hex_md5(str)
}

/**
 * 日期格式化
 * @param {*} fmt
 * @param {*} mills
 */
export function dateFormat (fmt, mills) {
  let ret, date = mills ? new Date(mills) : new Date()
  const opt = {
    'y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}
